export default "__VITE_ASSET__b447677b__"